import { allocationDesignerRoutes } from '@/allocation-designer/routes';
import auth from '@/auth/auth';
import LoginPage from '@/auth/pages/LoginPage.vue';
import CalendarPage from '@/calendar/pages/CalendarPage.vue';
import NotFoundPage from '@/components/NotFoundPage/NotFoundPage.vue';
import { config } from '@/config';
import DashboardPage from '@/dashboard/pages/DashboardPage.vue';
import { eventFullscreenRoutes, eventRoutes } from '@/event/routes';
import { externalEventRoutes } from '@/external_event/routes';
import { locationRoutes } from '@/location/routes';
import BaseLayout from '@/navigation/components/BaseLayout.vue';
import { projectRoutes } from '@/project/routes';
import { reportRoutes } from '@/report/routes';
import { scenarioRoutes } from '@/scenario/routes';
import MyProfilePage from '@/user/pages/MyProfilePage.vue';
import { userRoutes } from '@/user/routes';
import { createRouter, createWebHistory, RouteLocationNormalized } from 'vue-router';

export function _requireAuth(to: RouteLocationNormalized) {
    if (auth.isLoggedIn()) {
        return true;
    } else {
        return {
            path: '/login',
            query: { redirect: to.fullPath !== '/' ? to.fullPath : undefined },
        };
    }
}

// Route-guard for pages that require admin-permissions
export function requireAdmin(_to: RouteLocationNormalized) {
    if (auth.isAdmin()) {
        return true;
    } else {
        return { path: '/' };
    }
}

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: BaseLayout,
            props: {
                showEnvironmentName: config.showEnvName,
                hasEnvironmentNameMismatch: config.envName === 'devdb',
                versionJsonUrl: config.versionJsonUrl,
            },
            beforeEnter: _requireAuth,
            children: [
                {
                    path: '/',
                    name: 'dashboard',
                    component: DashboardPage,
                },
                ...eventRoutes,
                ...locationRoutes,
                ...externalEventRoutes,
                {
                    path: '/calendar',
                    name: 'calendar',
                    component: CalendarPage,
                },
                ...projectRoutes,
                ...userRoutes,
                ...scenarioRoutes,
                ...allocationDesignerRoutes,
                {
                    path: '/me',
                    name: 'me',
                    component: MyProfilePage,
                },
                {
                    path: '/:pathMatch(.*)*',
                    name: '404',
                    component: NotFoundPage,
                },
            ],
        },
        ...eventFullscreenRoutes,
        ...reportRoutes,
        {
            path: '/login',
            name: 'login',
            component: LoginPage,
            beforeEnter: () => {
                if (auth.isLoggedIn()) {
                    return { path: '/' };
                }
            },
            props: ({ query }) => ({
                redirect: query.redirect,
                initialError: query.error,
                initialMessage: query.message,
            }),
        },
        {
            path: '/logout',
            name: 'logout',
            redirect: () => {
                auth.logout();
                return { name: 'login' };
            },
        },
    ],
});

export default router;
